import { ContainerBadgeSize } from './types';

const containerBadgeSizeToPx: Record<ContainerBadgeSize, number> = {
  sm: 20,
  md: 24
};

export default containerBadgeSizeToPx;
